'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_components_MealPlanner$Props(onClose, onDeleteMeal, onMoveMeal, startDate, endDate) {
  this.LN = null;
  this.SA = null;
  this.LO = null;
  this.Dg = null;
  this.Df = null;
  this.LN = onClose;
  this.SA = onDeleteMeal;
  this.LO = onMoveMeal;
  this.Dg = startDate;
  this.Df = endDate;
}
export { $c_Lmealorama_components_MealPlanner$Props as $c_Lmealorama_components_MealPlanner$Props };
$p = $c_Lmealorama_components_MealPlanner$Props.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_components_MealPlanner$Props;
/** @constructor */
function $h_Lmealorama_components_MealPlanner$Props() {
}
export { $h_Lmealorama_components_MealPlanner$Props as $h_Lmealorama_components_MealPlanner$Props };
$h_Lmealorama_components_MealPlanner$Props.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, 418637176, true);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lmealorama_components_MealPlanner$Props) && (((($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().s(this.LN, x$0.LN) && $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().s(this.SA, x$0.SA)) && $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().s(this.LO, x$0.LO)) && $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().s(this.Dg, x$0.Dg)) && $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().s(this.Df, x$0.Df))));
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 5;
});
$p.r = (function() {
  return "Props";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.LN;
      break;
    }
    case 1: {
      return this.SA;
      break;
    }
    case 2: {
      return this.LO;
      break;
    }
    case 3: {
      return this.Dg;
      break;
    }
    case 4: {
      return this.Df;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lmealorama_components_MealPlanner$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kc)));
}
export { $isArrayOf_Lmealorama_components_MealPlanner$Props as $isArrayOf_Lmealorama_components_MealPlanner$Props };
var $d_Lmealorama_components_MealPlanner$Props = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_components_MealPlanner$Props, "mealorama.components.MealPlanner$Props", ({
  kc: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_components_MealPlanner$Props as $d_Lmealorama_components_MealPlanner$Props };
//# sourceMappingURL=mealorama.components.-Meal-Planner$-Props.js.map
